import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const LazyLoad = ({ children, className, style, onContentVisible, ...rest }) => {
  // Keep rendered structure stable while disabling lazy behavior.
  useEffect(() => {
    if (typeof onContentVisible === 'function') {
      onContentVisible();
    }
  }, [onContentVisible]);

  return (
    <div className={className} style={style} {...rest}>
      {children}
    </div>
  );
};

LazyLoad.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onContentVisible: PropTypes.func,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

LazyLoad.defaultProps = {
  children: null,
  className: '',
  onContentVisible: null,
  style: undefined,
};

export default LazyLoad;
